import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ScoresService {

  constructor(private http: HttpClient) { }

  //Score Ranking  APIs
  addScoreRanking(username: string, orgid: any, rankNameAr: string, rankNameEn: string, rankColor: string) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrranks/${username}`, { orgid, rankNameAr, rankNameEn, rankColor, active });
  }

  updateScoreRanking(username: string, id: number, orgid: any, rankNameAr: string, rankNameEn: string, rankColor: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrranks/${username}/${id}`, { id, orgid, rankNameAr, rankNameEn, rankColor, active });
  }

  getAllScoreRanking() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrranks`);
  }

  getScoreRankingBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrranks/${id}`);
  }

  //Assessment Unit  APIs
  addِِِAssesmentUnit(username: string, orgid: any, asesUnitNameAr: string, asesUnitNameEn: string) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrassessmentunits/${username}`, { orgid, asesUnitNameAr, asesUnitNameEn, active });
  }

  updateAssesmentUnit(username: string, id: number, orgid: any, asesUnitNameAr: string, asesUnitNameEn: string, active: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrassessmentunits/${username}/${id}`, { id, orgid, asesUnitNameAr, asesUnitNameEn, active });
  }

  getAllAssesmentUnit() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrassessmentunits`);
  }

  getAssesmentUnitBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrassessmentunits/${id}`);
  }

  addWLetterType(username: string, orgid: any, letterTypeObj: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrwarntypes/${username}`, { orgid, ...letterTypeObj, active });
  }

  updateWLetterType(username: string, id: number, orgid: any, letterTypeObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrwarntypes/${username}/${id}`, { id, orgid, ...letterTypeObj });
  }

  getAllWLetterTypes() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrwarntypes`);
  }

  getWLetterTypeBYId(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrwarntypes/${id}`);
  }

  // Course Assessment Units

  addCourseAssUnit(username: string, orgid: any, yearid: number, semesterid: number, gradeid: number, subjectid: number, courseUnitObj: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetup/${username}`, { orgid, yearid, semesterid, gradeid, subjectid, ...courseUnitObj, active, createdDate });
  }

  updateCourseAssUnit(username: string, id: number, orgid: any, courseUnitObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetup/${username}/${id}`, { id, orgid, ...courseUnitObj });
  }

  getAllCourseAssUnits() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetup`);
  }

  getCourseAssUnitById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetup/${id}`);
  }

  searchForCourseAssUnit(orgid: number, yearId: number, semesterId: number, batchId: number, courseId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetupbysemester/${orgid}/${yearId}/${semesterId}/${batchId}/${courseId}`);
  }


  // Warrning Letter Units

  addWarrningLetter(username: string, orgid: any, warrningLetterObj: any, yearid: any, semesterid: any, gradeid: any) {
    let createdDate = new Date();
    let active = "YES";
    let warnStatus = "DRAFT";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrstudentwarnings/${username}`, { orgid, ...warrningLetterObj, active, createdDate, yearid, semesterid, gradeid, warnStatus });
  }

  updateWarrningLetter(username: string, id: number, orgid: any, warrningLetterObj: any, yearid: any, semesterid: any, gradeid: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrstudentwarnings/${username}/${id}`, { id, orgid, ...warrningLetterObj, yearid, semesterid, gradeid });
  }

  getAllWarrningLetter() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrstudentwarnings`);
  }

  getWarrningLetterById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrstudentwarnings/${id}`);
  }

  getGradeStudents(orgid: number, yearId: number, semesterId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentbygrade/${orgid}/${yearId}/${semesterId}/${batchId}`);
  }

  searchForWarrningLetter(orgid: number, yearId: number, semesterId: number, batchId: number, type: number, group: number, student: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/getwarningsbyfilter/${orgid}/${yearId}/${semesterId}/${batchId}/${type}/${group}/${student}`);
  }

  copyPreviousSemesterAssessments(orgid: number, yearId: number, semesterId: number, username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/copyPreviousSemesterAssessments/${orgid}/${yearId}/${semesterId}/${username}`);
  }

  // Score data upload
  addScoreDataUpload(username: string, orgid: any, scoreDataObj: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessments/${username}`, { orgid, ...scoreDataObj, active });
  }

  // Score data upload
  updateScoreDataUpload(username: string, id: any, scoreDataObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessments/${username}/${id}`, scoreDataObj);
  }

  scoreDataUploadSearch(orgid: number, yearId: number, semesterId: number, batchId: number, sbjId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsbygrade/${orgid}/${yearId}/${semesterId}/${batchId}/${sbjId}`);
  }

  getAllScoreDataDetails() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessments`);
  }

  deleteScoreData(username: string, id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessments/${username}/${id}`);
  }

  scrUpdateAssessmentStatus(orgid: number, id: any, status: any, username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrupdateassessmentstatus/${orgid}/${id}/${status}/${username}`);
  }

  getScoreDataFileDetails(orgid: number, id: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrgetsubjasesbyheader/${orgid}/${id}`);
  }

  getUnitsBySbjId(sbj: number, orgid: number, yearId: number, semesterId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetupbysubject/${orgid}/${yearId}/${semesterId}/${batchId}/${sbj}`);
  }

  getAssUnitsByType(type: string, orgid: number, yearId: number, semesterId: number, batchId: number, sbjId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsetupbytype/${orgid}/${yearId}/${semesterId}/${batchId}/${sbjId}/${type}`);
  }

  uploadCSVFile(formDate: FormData, username: string, id: number) {
    return this.http.post<any>(
      `${environment.API_URL_UTIL}/api/uploadassexcel/${username}/${id}`, formDate);
  }

  generatestudentEligibilitReport(orgid: any, yearid: any, semesterid: any, groupid: any, studentid: any, lang: any, username: any, batchId: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatescrreport100/${orgid}/${yearid}/${semesterid}/${groupid}/${studentid}/${lang}/${username}/${batchId}`);
  }

  getstudentEligibilitReport(username: any) {
    let reportId = 100;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmatrixbyrepid/${username}/${reportId}`);
  }

  getScoresStudentEligibilityStatistic(username: any) {
    let reportId = 100;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmatrixreportsummaryvw/${reportId}/${username}`);
  }

  // Exams

  // Load Student
  loadStudentCourses(orgid: number, yearId: number, semesterId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmfinalsubjectsbygrade/${orgid}/${yearId}/${semesterId}/${batchId}`);

    // TEST data start
    // return of([
    //   {
    //     "id": 1,
    //     "subjectid": 10,
    //     "remarks": "hadahdghagshd",
    //     "status": "DRAFT"
    //   },
    //   {
    //     "id": 2,
    //     "subjectid": 20,
    //     "remarks": "hadahdghagshd",
    //     "status": "SUBMITTED"
    //   },
    //   {
    //     "id": 2,
    //     "subjectid": 30,
    //     "remarks": "hadahdghagshd",
    //     "status": "CANCELLED"
    //   }
    // ]).pipe(map(data => data), catchError(e => of('Error Oops!')));
    // TEST data end
  }
  // Load Student
  loadStudentCoursessubmitted(orgid: number, yearId: number, semesterId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmfinalsubjectssubmittedbygrade/${orgid}/${yearId}/${semesterId}/${batchId}`);

  }
  loadAndReloadStudentCourses(orgid: number, yearId: number, semesterId: number, batchId: number, username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/loadreloadexmassessments/${orgid}/${yearId}/${semesterId}/${batchId}/${username}`);
  }

  updateLoadStudentCourses(orgid: number, id: number, username: string, examFinalSbjObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/exmfinalsubjects/${username}/${id}`, { orgid, ...examFinalSbjObj });
  }

  getLoadStudentDetails(orgid: number, examFinalId: number) {
    // return this.http.get<any>(
    //   `${environment.API_URL_ADM}/api/exmfinalsubjectstudentsbyheader/${orgid}/${examFinalId}`);
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmfinalsubjectstudentsvwbyheader/${orgid}/${examFinalId}`);
  }
  updateScoreDetialsOngoing(username: string, id: any, scoreDataObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentstudents/${username}/${id}`, scoreDataObj);
  }
  // Get reviews and release
  getReviewsAndRelease(orgid: number, yearId: number, semesterId: number, batchId: number, courseId: number) {
    // TEST data start
    return of([
      {
        "id": 1,
        "subjectid": 10,
        "remarks": "hadahdghagshd1",
        "status": "DRAFT"
      },
      {
        "id": 2,
        "subjectid": 20,
        "remarks": "hadahdghagshd2",
        "status": "SUBMITTED"
      },
      {
        "id": 2,
        "subjectid": 30,
        "remarks": "hadahdghagshd3",
        "status": "CANCELLED"
      }
    ]).pipe(map(data => data), catchError(e => of('Error Oops!')));
    // TEST data end
  }

  updateExamToFinal(orgid: number, headerId: number, username: string) {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/finalizeexamstudentsresults/${orgid}/${headerId}/${username}`);
  }

  // Get ongoing examinations  reviewal
  getOngoingExamReviewal(orgid: number, yearId: number, semesterId: number, batchId: number, type: string) {
    // TEST data start
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrsubjectassessmentsbytype/${orgid}/${yearId}/${semesterId}/${batchId}/${type}`);

  }

  // Get Final Examinations
  getFinalExaminationsData(orgid: number, yearId: number, semesterId: number, batchId: number, courseId: number) {
    // TEST data start
    return of([
      {
        "id": 50034,
        "subjectid": 10,
        "sbjasesid": 10,
        "filename": 'test1.csv',
        "remarks": "hadahdghagshd1",
        "status": "DRAFT"
      },
      {
        "id": 2,
        "subjectid": 20,
        "sbjasesid": 20,
        "filename": 'test2.csv',
        "remarks": "hadahdghagshd2",
        "status": "SUBMITTED"
      },
      {
        "id": 2,
        "subjectid": 30,
        "sbjasesid": 10,
        // "filename": 'test3.csv',
        "remarks": "hadahdghagshd3",
        "status": "CANCELLED"
      }
    ]).pipe(map(data => data), catchError(e => of('Error Oops!')));
    // TEST data end
  }

  // Re-Taken exam
  getReTakeExamData(orgid: number, yearId: number, semesterId: number, batchId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmretakesbygrade/${orgid}/${yearId}/${semesterId}/${batchId}`);
  }

  updateRetakenExamData(orgid: number, id: number, username: string, retakenExamObj: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/exmretakes/${username}/${id}`, { orgid, ...retakenExamObj });
  }
  // Score data upload
  addRetakenExamData(username: string, orgid: any, retakenExamObj: any) {
    let createdDate = new Date();
    let active = "YES";
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/exmretakes/${username}`, { orgid, ...retakenExamObj, active });
  }

  generateOngoingAssesmentReport(orgid: any, yearid: any, semesterid: any, batchid: any, subjectid: any, groupid: any, studentid: any, lang: any, username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatescrreport200/${orgid}/${yearid}/${semesterid}/${batchid}/${subjectid}/${groupid}/${studentid}/${lang}/${username}`);
  }

  getOngoingAssesmentReport(username: any) {
    let reportId = 200;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmatrixbyrepid/${username}/${reportId}`);
  }

  generateCohortOngoingReport(orgid: any, yearid: any, semesterid: any, batchid: any, lang: any, username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatescrreport300/${orgid}/${yearid}/${semesterid}/${batchid}/${lang}/${username}`);
  }

  getCohortOngoingReport(username: any) {
    let reportId = 300;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmatrixbyrepid/${username}/${reportId}`);
  }

  getAcademicAndClinicalWarningReport(orgid: any, yearid: any, semesterid: any, subjectid: any, studentid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrstudentwarningvw/${orgid}/${yearid}/${semesterid}/${subjectid}/${studentid}`);
  }

  getWarrningLetterPrintHtml(id: number) {
    let orgId = 10;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrgetwrnletter/${orgId}/${id}/en`);
  }

  getExaminationsExtractByExamReport(orgid: any, yearid: any, semesterid: any, batchid: any, subjectid: any, assessmentid: any, groupid: any, studentid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrasessummaryvw/${orgid}/${yearid}/${semesterid}/${batchid}/${subjectid}/${assessmentid}/${studentid}/${groupid}`);
  }

  generateCumulativePerformanceReport(orgid: any, yearid: any, semesterid: any, batchid: any, lang: any, username: any) {
    // return of([
    //   {
    //     "id": 1,
    //     "subjectid": 10,
    //     "remarks": "hadahdghagshd",
    //     "status": "DRAFT"
    //   }]);
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generatescrreport400/${orgid}/${yearid}/${semesterid}/${batchid}/${lang}/${username}`);
  }

  getCumulativePerformanceReport(username: any) {
    let reportId = 400;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/scrmatrixbyrepid/${username}/${reportId}`);
  }

  generateFirstExamReport(orgid: any, yearid: any, semesterid: any, batchid: any, subjectid: any, lang: any, username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generateexmreport100/${orgid}/${yearid}/${semesterid}/${batchid}/${subjectid}/${lang}/${username}`);
  }

  getFirstExamReport(username: any) {
    let reportId = 100;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmmatrixbyrepid/${username}/${reportId}`);
  }

  generateSecondExamReport(orgid: any, yearid: any, semesterid: any, batchid: any, subjectid: any, lang: any, username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/generateexmreport200/${orgid}/${yearid}/${semesterid}/${batchid}/${subjectid}/${lang}/${username}`);
  }

  getSecondExamReport(username: any) {
    let reportId = 200;
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/exmmatrixbyrepid/${username}/${reportId}`);
  }
}
